export enum DynamicStrategyType {
    CHEAP_ONE_COST_STRATEGY = "cheapOneCostStrategy",
    SHARE_COST_STRATEGY = "shareCostStrategy",
    PRIORITY_COST_PRIORITY = "priorityCostStrategy",
    ENVIRONMENT_COST_STRTEGY = "environmentCostStrategy"
}